import http from './api'

export interface CreatePaymentIntentRequest {
  amountCents: number
  currency: string
  serviceType: string
  metadata?: Record<string, unknown>
}

export interface CreatePaymentIntentResponse {
  clientSecret: string
  paymentId: string
  amountCents: number
  currency: string
}

export interface PaymentItem {
  id: string
  userId: string
  stripePaymentIntentId: string
  amountCents: number
  currency: string
  status: string
  serviceType: string
  metadata: Record<string, unknown> | null
  createdAt: string
  updatedAt: string
}

export async function createPaymentIntent(
  body: CreatePaymentIntentRequest
): Promise<CreatePaymentIntentResponse> {
  const { data } = await http.post<CreatePaymentIntentResponse>(
    '/payments/create-intent',
    body
  )
  return data
}

export async function getMyPayments(): Promise<PaymentItem[]> {
  const { data } = await http.get<PaymentItem[]>('/payments/me')
  return data
}
